import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { globalQueryKeys } from '@opallabs/api'
import { content, OpalApiResponseDocument } from '@opallabs/api/v3'
import { type ReadableAccessMetadata } from '@opallabs/concepts'

type UseReadContentAccessParams = UseQueryOptions<
  OpalApiResponseDocument<'ReadContentV3', 200>
> & {
  contentUuid: string
}

export const useReadContentAccess = (params: UseReadContentAccessParams) =>
  useQuery({
    queryKey: globalQueryKeys.contentAccess(params.contentUuid),
    queryFn: () =>
      content.readSingle({
        path: {
          content_id: params.contentUuid,
        },
        query: {
          expose: {
            meta: {
              access: 'true',
            },
          },
        },
      }),
    enabled: params.enabled,
    refetchOnMount: params.refetchOnMount,
    select: (responseDocument): ReadableAccessMetadata | undefined =>
      responseDocument.meta?.access,
  })
